import { Layout } from '../components/Layout';
import { SignInForm } from '../components/SignInForm';

export const SignIn = () => {
  return (
    <Layout>
      <SignInForm />
    </Layout>
  );
};
